module.exports = __webpack_public_path__ + "static/desktop_32_38_34-d30f5b3a753020e65ca02b4d1e49634e.png";